<script>
import store from "../../public/store/store";

export default {
    name: "SingleItem",
    props: ['itemId', 'hash'],
    data() {
        return {
            item: {},
            loading: true,
            message: 'Загрузка...',
        }
    },
    created() {
        store.commit('setCurrentHash', this.hash);
        let data = {
            hash: this.hash,
            itemId: this.itemId,
        };

        axios.post(`/rest/share/section/item`, data).then((response) => {
            this.item = response.data.item;
            this.loading = false;
        }).catch((error) => {
            if (error.response.status === 404) {
                this.message = 'Элемент не найден.';
            }
        });
    },
}
</script>

<template>
    <div>
        <div v-if="loading === false">
            <div class="created_at">
                Дата создания: {{ this.item.created_at }}
            </div>
            <div class="title">
                <h2>{{ this.item.name }}</h2>
            </div>
            <div v-if="this.item.description" class="description" v-html="this.item.description"></div>
            <div v-html="this.item.text">
            </div>
        </div>
        <div v-else>
            {{ this.message }}
        </div>
    </div>
</template>

<style scoped>
.title {
    margin-bottom: 30px;
}

.created_at {
    margin-bottom: 30px;
}
</style>
